<template>
  <div
    class="booking-for-input"
    aria-live="polite"
  >
    <MenuLabel
      class="booking-for-input__menu-label"
      :label="$t('STAY_BROWSE_ROOMS_BOOKING_OTHERS_LABEL')"
      :isOpen="isOpen"
      :last="true"
      :value="$t(selectedBookingType.label)"
      @toggle="handleMenuToggled"
      @focusDropdown="focusFirstItem"
    />
    <component
      :is="$device.isMobile ? 'Drawer' : 'DropdownMenu'"
      :visible="isOpen"
      class="location-input__menu-container"
      :title="$t('STAY_BROWSE_ROOMS_BOOKING_OTHERS_LABEL')"
      @close="handleMenuToggled"
    >
      <ul class="booking-for-input__list-wrapper">
        <MenuItem
          v-for="bookingType in bookingTypes"
          :key="bookingType.label"
          :label="$t(bookingType.label)"
          :value="bookingType.code"
          :selected="selectedBookingType.label === bookingType.label"
          :isDisabled="!bookingType.enabled"
          :isNotAllowed="!bookingType.enabled"
          :ref="bookingType.label"
          @click="handleMenuItemClicked(bookingType)"
        />
      </ul>
      <template v-if="$device.isMobile" #footer>
        <ShButton
          @click="handleMenuToggled"
          :fullWidth="true"
          :disabled="!Boolean(selectedBookingType.value)"
        >
          {{ $t('STAY_MODIFY_BOOKING_CONFIRM_CTA') }}
        </ShButton>
      </template>
    </component>
  </div>
</template>

<script>
import { DropdownMenu, MenuItem, MenuLabel, Drawer } from '@sohohouse/design-system'
import get from '~/helpers/get'

export default {
  name: 'BedroomsBookingForMenu',
  components: {
    DropdownMenu,
    MenuItem,
    MenuLabel,
    Drawer
  },

  props: {
    selectedBookingType: {
      type: Object,
      default: () => ({
        code: '',
        label: ''
      })
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    bookingTypes: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleMenuToggled () {
      return this.$emit('menuToggle')
    },
    handleMenuItemClicked (bookingType) {
      return this.$emit('itemSelected', bookingType)
    },
    focusFirstItem () {
      const refs = Object.values(this.$refs)
      const el = get(refs, '0.0.$el')
      if (el) {
        el.focus()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.booking-for-input {
  &__menu-label {
    border-top-width: 0;

    @include tablet {
      border-top-width: 1px;
    }
  }

  &__list-wrapper {
    margin: 0;
    padding: 0;
  }
}
</style>
